export class UserInformationRequest {
    data: UserInformationRequestData = {
        patientInfo: {
            firstName: "",
            lastName: "",
            dob: "",
            gender: "",
            email: "",
            phoneMobile: ""
        },
        patientAddresses: [
            {
                addressType: 0,
                addressLine1: "",
                addressLine2: "",
                state: "",
                cityName: "",
                countryName: "",
                stateName: "",
                country: "",
                zipCode: ""
            }
        ],
        timeZone: ""
    }
    constructor(init?: any) {
        if (init) {
            this.data.patientInfo = this.mapPatientInfo(init?.profile)
            this.data.patientAddresses[0] = this.mapAddressInfo(init?.address)
            console.log(init?.address);
            
            this.data.timeZone = init?.address.timeZone
        }
    }
    mapPatientInfo(patientInfo: Profile) {
        const response: PatientInfo = {
            dob : patientInfo.dateOfBirth,
            email: patientInfo.email,
            gender: patientInfo.gender,
            phoneMobile: patientInfo.phoneMobile,
            firstName: patientInfo.firstName,
            lastName: patientInfo.lastName,
        }
        return response
    }
    mapAddressInfo(addressInfo: Address) {
        const response: PatientAddress = {
            cityName: addressInfo.city,
            state: addressInfo.stateId,
            stateName : addressInfo.state,
            zipCode: addressInfo.zipCode,
            countryName: addressInfo.country,
            country : addressInfo.countryId,
            addressLine1: addressInfo.addressLine1,
            addressLine2: addressInfo.addressLine2,
            addressType: addressInfo.addressType
        }
        return response
    }
}
export interface UserInformationRequestData {
    patientInfo: PatientInfo
    patientAddresses: Array<PatientAddress>,
    timeZone : string
}
interface Address {
    city: string
    state: string
    zipCode: string
    country: string,
    timeZone: string
    addressType: number,
    addressLine1: string,
    addressLine2: string,
    stateId: string,
    countryId: string,
}
interface Profile {
    displayName: string
    email: string
    dateOfBirth: string
    gender: string
    phoneMobile: string,
    firstName: string,
    lastName: string
}
interface PatientInfo {
    firstName: string
    lastName: string
    email: string
    dob: string
    gender: string
    phoneMobile: string

}
interface PatientAddress {
    cityName: string
    addressLine1: string
    addressLine2: string
    stateName: string
    zipCode: string
    countryName: string
    addressType: number
    state: string,
    country: string
}